/** @flow */
import * as React from 'react';
// import styled from 'styled-components';

/** Custom import's */
import t from '../../application/translate';

import Part02 from './accordionParts/Part02';
import Part03 from './accordionParts/Part03';
import Part04 from './accordionParts/Part04';

const { Component } = React;

const components = {
  part2: Part02,
  part3: Part03,
  part4: Part04,
};

const Parts = ({i, components}) => {
  const Comp = components[`part${i}`];
  return (
    <Comp key={i} />
  );
};

// const Result = styled.div.attrs({
//   className: 'text-center text-3xl font-semibold px-4 pb-3 text-green bg-white',
// })``;

class HowGetVisa extends Component<Props & ProvidedProps, State> {

  render() {

    let accordion = [];

    function GetAccordion() {

      for(let i = 2; i < 5; i++) {
        accordion.push(
          <div key={i} className="tab relative overflow-hidden w-full border-t border-solid border-grey-lighter">
            <input id={i} type="checkbox" name="accordion" className="absolute -z-1 opacity-0" />
            <label htmlFor={i} className="relative block cursor-pointer font-bold py-4 pr-9">
              {t('howGetVisa/documents/doc0' + i +'/title')}
            </label>
            <div className="tab-content overflow-hidden leading-normal">
              <div className="pt-6 pb-8">
                <Parts
                  i={i}
                  components={components}
                />
              </div>
            </div>
          </div>
        );
      }
      return accordion;
    }

    GetAccordion();

    return (
      <div>
        <div>
          <div className="text-3xl text-semibold pb-9">
            {t('howGetVisa/title')}
          </div>
          <blockquote className="leading-normal pb-9">
            {t('howGetVisa/text')}
          </blockquote>
        </div>
        <div className="border-b border-solid border-grey-lighter">
          <div className="tab relative overflow-hidden w-full border-t border-solid border-grey-lighter">
            <label className="relative block cursor-pointer font-bold py-4 pr-9">
              {t('howGetVisa/documents/doc01/title')}
            </label>
          </div>
          {accordion}
        </div>
        <div className="text-grey-text py-9 text-xs leading-normal">
          {t('howGetVisa/info')}
        </div>
      </div>
    );
  }

}

export default HowGetVisa;



// WEBPACK FOOTER //
// ./src/components/VisaCheckingForm/HowGetVisa.js